var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#C97523"
    },
    points: "134.902,346.198 134.902,449.907 91.392,449.907 91.392,346.181 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#A85613"
    },
    points: "110.799,346.198 110.799,449.907 91.392,449.907 91.392,346.181 "
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#8CC928"
    },
    cx: 113.147,
    cy: 203.01,
    rx: 105.558,
    ry: 165.946
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82B20B"
    },
    d: "M113.147,368.958c-58.304,0-105.558-74.301-105.558-165.946S54.843,37.067,113.147,37.067 c-25.813,0-46.728,74.301-46.728,165.946S87.334,368.958,113.147,368.958z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E9EAEF"
    },
    points: "462.392,263.647 462.392,474.931 185.202,474.931 185.202,263.647 324.579,128.443 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#9EB1B7"
    },
    points: "394.569,189.049 394.569,150.021 463.867,150.021 463.867,255.044 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 337.072,
    y: 430.659,
    style: {
      fill: "#85C10D"
    },
    width: 167.342,
    height: 44.274
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.589,
    y: 430.659,
    style: {
      fill: "#85C10D"
    },
    width: 189.552,
    height: 44.274
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D2D4D8"
    },
    points: "462.392,271.941 462.392,311.433 323.797,179.104 185.202,311.433 185.202,271.941  312.791,150.426 323.797,140.201 334.796,150.426 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EA4756"
    },
    points: "323.795,157.127 165.995,307.784 143.931,289.261 312.792,128.443 323.795,118.223  334.797,128.443 503.659,289.261 481.595,307.784 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.109,
    y: 316.632,
    style: {
      fill: "#C97523"
    },
    width: 91.412,
    height: 158.296
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.072,
    y: 316.632,
    style: {
      fill: "#A0D9F2"
    },
    width: 104.101,
    height: 91.412
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.072,
    y: 316.632,
    style: {
      fill: "#C97523"
    },
    width: 104.101,
    height: 27.778
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#413740"
    },
    cx: 323.796,
    cy: 245.994,
    r: 25.428
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.067,415.633h104.099c4.192,0,7.589-3.398,7.589-7.589V316.63c0-4.191-3.397-7.589-7.589-7.589H337.067 c-4.192,0-7.589,3.398-7.589,7.589v91.414C329.478,412.236,332.876,415.633,337.067,415.633z M344.656,400.455v-48.458h88.921 v48.458H344.656z M433.577,324.219v12.601h-88.921v-12.601H433.577z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M504.411,423.069h-34.429v-64.923c0-4.191-3.398-7.589-7.589-7.589l0,0c-4.191,0-7.589,3.398-7.589,7.589v64.923H337.067 c-4.191,0-7.589,3.398-7.589,7.589v36.684h-11.362V316.63c0-4.191-3.398-7.589-7.589-7.589h-91.414 c-4.191,0-7.589,3.398-7.589,7.589v150.712h-6.792v-36.684c0-4.191-3.398-7.589-7.589-7.589h-4.353V292.692L323.794,167.62 l131.009,125.078v30.031c0,4.191,3.398,7.589,7.589,7.589l0,0c4.191,0,7.589-3.398,7.589-7.589v-15.54l6.373,6.084 c2.798,2.671,7.157,2.81,10.119,0.324l21.899-18.383c1.016-0.853,1.862-1.914,2.344-3.15c1.163-2.98,0.36-6.219-1.823-8.298 l-37.437-35.653v-98.091c0-4.191-3.398-7.589-7.589-7.589h-69.297c-4.191,0-7.589,3.398-7.589,7.589v17.64l-47.018-44.778 l-11.002-10.22c-2.911-2.705-7.415-2.705-10.33,0l-11.071,10.286l-81.294,77.421c-0.571-57.699-19.797-111.241-50.902-142.572 c-3.083-3.105-8.171-2.905-11.056,0.387l0,0c-2.637,3.007-2.471,7.527,0.348,10.365c28.804,28.978,46.461,79.654,46.461,134.463 c0,4.044-0.122,8.085-0.312,12.081l-72.107,68.672c-2.182,2.079-2.985,5.317-1.822,8.298c0.482,1.236,1.328,2.297,2.343,3.15 l21.898,18.383c1.415,1.188,3.148,1.777,4.878,1.777c1.892,0,3.779-0.704,5.241-2.1l6.379-6.089v14.719 c-17.956,25.469-40.777,39.468-64.467,39.468c-25.506,0-49.739-16.014-68.236-45.091c-19.173-30.143-29.733-70.368-29.733-113.267 s10.56-83.124,29.734-113.266c18.495-29.077,42.729-45.091,68.236-45.091c8.859,0,17.598,1.932,26.061,5.75 c3.54,1.597,7.715,0.174,9.634-3.203v-0.001c2.209-3.889,0.593-8.84-3.484-10.675c-10.398-4.682-21.2-7.05-32.211-7.05 c-30.881,0-59.663,18.51-81.042,52.122C11.402,114.146,0,157.265,0,203.013s11.402,88.866,32.105,121.413 c14.41,22.655,32.186,38.437,51.698,46.326v52.316H60.712v-11.292c0-4.156-3.203-7.779-7.356-7.904 c-4.297-0.129-7.822,3.317-7.822,7.586v11.611h-9.199v-11.292c0-4.156-3.203-7.779-7.356-7.904 c-4.297-0.129-7.822,3.317-7.822,7.586v11.611H7.589c-4.191,0-7.589,3.398-7.589,7.589v44.274c0,4.191,3.398,7.589,7.589,7.589 h189.555c0.007,0,0.013-0.001,0.019-0.001h21.95h91.414h26.52c0.007,0,0.013,0.001,0.019,0.001h167.344 c4.191,0,7.589-3.398,7.589-7.589v-44.274C512,426.466,508.602,423.069,504.411,423.069z M402.158,157.61h54.12v76.048 l-54.12-51.541V157.61z M165.67,297.602l-10.36-8.697l162.648-154.9l5.838-5.423l5.769,5.358l162.718,154.965l-10.361,8.698 L329.036,151.638c-1.466-1.4-3.352-2.1-5.24-2.1c-1.886,0-3.774,0.7-5.24,2.1L165.67,297.602z M177.613,345.901v77.168h-9.972 v-11.611c0-4.191-3.397-7.589-7.589-7.589s-7.589,3.398-7.589,7.589v11.611h-9.972v-52.343 C155.051,365.63,166.915,357.254,177.613,345.901z M98.981,375.228c4.659,0.874,9.387,1.319,14.166,1.319 c4.773,0,9.501-0.455,14.166-1.337v47.858H98.981V375.228z M15.178,438.247h76.126c0.029,0,0.059,0.004,0.088,0.004h43.51 c0.029,0,0.059-0.004,0.088-0.004h54.566v29.095h-4.353v0.001H15.178V438.247z M226.703,467.342V324.219h76.236v143.123H226.703z  M496.822,467.343h-34.429v-0.001H344.656v-29.095h152.166V467.343z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M292.515,387.684h-13.269c-4.192,0-7.589,3.398-7.589,7.589s3.397,7.589,7.589,7.589h13.269 c4.192,0,7.589-3.398,7.589-7.589S296.707,387.684,292.515,387.684z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M356.82,245.996c0-18.207-14.814-33.021-33.022-33.021c-18.207,0-33.021,14.814-33.021,33.021 c0,18.208,14.814,33.021,33.021,33.021C342.006,279.017,356.82,264.204,356.82,245.996z M323.797,263.839 c-9.839,0-17.843-8.005-17.843-17.843c0-9.838,8.004-17.843,17.843-17.843c9.839,0,17.844,8.005,17.844,17.843 C341.642,255.835,333.637,263.839,323.797,263.839z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.1c1c94c1344f1bc6cd09f792438e5ecb.svg";
export { ForwardRef as ReactComponent };